import React from "react";

const FooterComponent = () => {
  return (
    <footer className="footer">
      <div className="footer_top">
        <div className="container">
          <div className="row" style={{ paddingBottom: "90px" }}>
            <div className="col-xl-4 col-md-6 col-lg-4">
              <div className="footer_widget">
                <div className="footer_logo">
                  <a className="footer_logo_anchor_tag" href="/">
                    <img
                      className="dawaasaan_logo"
                      src={require("../../assets/images/Logo.png")}
                    />
                  </a>
                  <a href="https://www.servaid.com.pk/" target="blank">
                    <img
                      className="img-fluid servaid_logo"
                      src={require("../../assets/images/servaid.png")}
                    // style={{ width: "150px" }}
                    />
                  </a>

                </div>
                <p style={{ fontSize: "11px", color: "#212529", fontWeight: "700" }} className="text_responsive_footer"></p>
                <nav className="navbar navbar-expand-lg h2-nav pl-0">
                  <ul className="navbar-nav footer_nav_section">
                    <li className="nav-item active mr-2">
                      <a
                        href="https://apps.apple.com/pk/app/dawa-asaan/id1528679507"
                        target="blank"
                      >
                        <img className="img-fluid footer_playstore" src={require("../../assets/images/ios.png")}></img>
                      </a>
                    </li>
                    <li className="nav-item active">
                      <a href="https://play.google.com/store/apps/details?id=com.novatorsols.dawaasaan" target="blank">
                        <img
                          className="img-fluid footer_playstore"
                          src={require("../../assets/images/google.png")}
                        ></img>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-xl-2 offset-xl-1 col-md-6 col-lg-3">
              <div className="footer_widget">
                {/* <h3 className="footer_title">Departments</h3> */}
                <ul type="none" className="pl-0">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="/howitworks">How it Works</a>
                  </li>
                  <li>
                    <a href="/medical-services">Home Medical Services</a>
                  </li>
                  <li>
                    <a href="/blog">Blogs</a>
                  </li>
                  <li>
                    <a href="/contact">Contact Us</a>
                  </li>
                  <li>
                    <a href="/privacy">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="/offers">Offers</a>
                  </li>
                  <li>
                    <a href="/offering">Outsourcing Services</a>
                  </li>
                  {/* <li>
                    <a href="/terms">Terms & Services</a>
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="col-xl-5 col-md-12 col-lg-5">
              <div className="footer_widget footer_subscribed">
                <h3 className="footer_title pr-1">
                  Subscribe to our newsletter
                </h3>
                <div style={{ position: "relative" }}>
                  <input
                    className="form-control footer_search pl-4"
                    type="search"
                    placeholder="Search topics or keywords"
                    style={{ paddingRight: "124px", paddingTop: "1px" }}
                  />
                  <button
                    className="btn btn-lg action_button_blog_footer"
                    type="button"
                  >
                    Subscribe
                  </button>
                </div>
                <div className="socail_links">
                  <ul className="pl-0 social_links_alignment">
                    <li>
                      <a href="https://www.facebook.com/Dawa-Asaan-106602731175351/" target="blank">
                        <i className="fa fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/channel/UCXa7KMTv3w-WgcaBuvGPgHA/?guided_help_flow=5" target="blank">
                        <i className="fa fa-youtube"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://instagram.com/dawaasaan?igshid=1cs4hwfyo0u30" target="blank">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12.901"
                          height="12.898"
                          viewBox="0 0 12.901 12.898"
                        >
                          <defs>
                            <style
                              dangerouslySetInnerHTML={{
                                __html: ".a{fill:#212529;}",
                              }}
                            />
                          </defs>
                          <path
                            className="a"
                            d="M6.447,5.38A3.307,3.307,0,1,0,9.754,8.687,3.3,3.3,0,0,0,6.447,5.38Zm0,5.457A2.15,2.15,0,1,1,8.6,8.687a2.154,2.154,0,0,1-2.15,2.15ZM10.66,5.245a.771.771,0,1,1-.771-.771A.77.77,0,0,1,10.66,5.245Zm2.19.783a3.817,3.817,0,0,0-1.042-2.7,3.842,3.842,0,0,0-2.7-1.042c-1.065-.06-4.257-.06-5.322,0a3.837,3.837,0,0,0-2.7,1.039A3.83,3.83,0,0,0,.04,6.025c-.06,1.065-.06,4.257,0,5.322a3.817,3.817,0,0,0,1.042,2.7,3.847,3.847,0,0,0,2.7,1.042c1.065.06,4.257.06,5.322,0a3.817,3.817,0,0,0,2.7-1.042,3.842,3.842,0,0,0,1.042-2.7c.06-1.065.06-4.254,0-5.319Zm-1.376,6.461a2.177,2.177,0,0,1-1.226,1.226,14.215,14.215,0,0,1-3.8.259,14.326,14.326,0,0,1-3.8-.259,2.177,2.177,0,0,1-1.226-1.226,14.215,14.215,0,0,1-.259-3.8,14.326,14.326,0,0,1,.259-3.8A2.177,2.177,0,0,1,2.645,3.659a14.215,14.215,0,0,1,3.8-.259,14.326,14.326,0,0,1,3.8.259,2.177,2.177,0,0,1,1.226,1.226,14.215,14.215,0,0,1,.259,3.8A14.206,14.206,0,0,1,11.475,12.489Z"
                            transform="translate(0.005 -2.238)"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div
                className="align-items-end d-flex justify-content-center height_calculate_footer">
                <p style={{ fontSize: "11px", color: "#212529", fontWeight: "600" }}>
                  Copyright © 2021 Dawaaa Asaan. All rights reserved. Designed and
                  Developed by Novatore Solutions
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterComponent;
